import App, { history } from 'containers/App/App';
import { ServiceWorkerProvider } from 'helpers/Hooks/useServiceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { configureAppStore } from '@ifca-root/react-component/src/store/configureStore';
import { Provider } from 'react-redux';
import { AudioProvider } from './Audio/AudioContext';


const store = configureAppStore();

// ServiceWorkerProvider is the single SW registration owner (no bare register()).
//Strict mode checks are run in development mode only; they do not impact the production build.
ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ServiceWorkerProvider history={history}>
      <AudioProvider>
        <App />
      </AudioProvider>
    </ServiceWorkerProvider>
  </Provider>,
  // </React.StrictMode>
  document.getElementById('root'),
);
